import { render, staticRenderFns } from "./RewardECoupon.vue?vue&type=template&id=3020f8c2&"
import script from "./RewardECoupon.vue?vue&type=script&lang=js&"
export * from "./RewardECoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports